import { useState, useEffect } from 'react';
import MultiSelect from './MultiSelect';
import SearchInput from './SearchInput';

const VehicleSelect = (props) => {
    const [filters, setFilters] = useState({
        brand: [],
        model: [],
        facility: [],
    });
    const [facets, setFacets] = useState({});
    const [search, setSearch] = useState('');

    const handleChangeSelect = (filter, value) => {
        setFilters(prevState => {
            return {
                ...prevState,
                [filter]: value
            }
        });
    };

    const handleClick = () => {
        let url = '/bilar-i-lager/';

        let params = [];

        for (let [key, value] of Object.entries(filters)) {
            if (value.length > 0) {
                params.push(`${key}=${value}`);
            }
        }

        if (search.length > 0) {
            params.push(`search=${search}`);
        }

        url += '?' + params.join('&');

        window.location = url;
    };

    const sortFacets = (facets) => {
        for (let [name, values] of Object.entries(facets)) {
            // sort by label first
            values = values.sort((a, b) => {
                return a.label.localeCompare(b.label, 'sv');
            });

            if (name === 'facility' || name === 'model') {
                // non-zero first
                values = values.sort((a, b) => {
                    if (parseInt(a.count) === 0) {
                        return 1;
                    }
                    if (parseInt(b.count) === 0) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                // sort by count
                values = values.sort((a, b) => {
                    if (parseInt(a.count) < parseInt(b.count)) {
                        return 1;
                    }
                    if (parseInt(a.count) > parseInt(b.count)) {
                        return -1;
                    }
                    return 0;
                });
            }

            facets[name] = values.map((item) => {
                return {
                    label: `${item.label} (${item.count})`,
                    value: item.value,
                    count: item.count,
                };
            });
        }

        return facets;
    }

    const id = Date.now();

    useEffect(() => {
        let url = horizon.ajaxUrl + '?action=nobox_vehicles_search';

        for (let [key, value] of Object.entries(filters)) {
            if (value.length > 0) {
                url += `&${key}=${value}`;
            }
        }

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                setFacets(sortFacets(data.facets));
            })
            .catch((error) => {
                console.error(error);
            });
    }, [filters]);

    return (
        <div className="vehicleselect">
            <div className="vehicleselect-row">
                <div className="vehicleselect-item">
                    <label id="downshift-0-label" htmlFor={'brand_' + id}>Märken</label>
                    <MultiSelect id={'brand_' + id} placeholder="Alla märken" items={facets.brand} values={filters.brand} onChange={(values) => handleChangeSelect('brand', values)} />
                </div>
                <div className="vehicleselect-item">
                    <label id="downshift-1-label" htmlFor={'model_' + id}>Modeller</label>
                    <MultiSelect id={'model_' + id} placeholder="Alla modeller" items={facets.model} values={filters.model} onChange={(values) => handleChangeSelect('model', values)} />
                </div>
            </div>
            <div className="vehicleselect-row">
                <div className="vehicleselect-item">
                    <label htmlFor={'search_' + id}>Sök</label>
                    <SearchInput id={'search_' + id} placeholder="Sök på version, utrustning, etc." value={search} setValue={setSearch} />
                </div>
                <div className="vehicleselect-item">
                    <label id="downshift-2-label" htmlFor={'facility_' + id}>Anläggningar</label>
                    <MultiSelect id={'facility_' + id} placeholder="Alla anläggningar" items={facets.facility} values={filters.facility} onChange={(values) => handleChangeSelect('facility', values)} />
                </div>
            </div>
            <div className="vehicleselect-row">
                <div className="vehicleselect-item button-wrapper">
                    <button className="button button--primary" onClick={handleClick}>Se bilar</button>
                </div>
            </div>
        </div>
    );
}

export default VehicleSelect;
